<template>
  <div>
    <div v-title data-title="使用帮助"></div>
    <div class="help-header">
      <span><i class="el-icon-back" style="cursor:pointer" @click="backhome"></i>&nbsp;&nbsp;使用帮助</span>
    </div>
    <div class="help-sider">
      <el-col>
        <el-menu default-active="2" class="el-menu-vertical-demo">
          <el-submenu index="1">
            <template slot="title">
              <span>使用帮助</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1-1" @click="tosupplier" class="el-icon-s-check">供应商应用系统</el-menu-item>
              <el-menu-item index="1-2" @click="todevelopers" class="el-icon-s-check">开发商应用系统</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
    </div>
    <div class="help-main">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        tosupplier() {
            this.$router.push({path:'/supplier'})
        },
        todevelopers() {
          this.$router.push({path:'/developers'})
        },
        backhome() {
          this.$router.push({path:'/homepage'})
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../style/homepage/usehelp.scss";
</style>


// WEBPACK FOOTER //
// src/components/homepage/UseHelp.vue